import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  allow = [
    '/pages/login',
    '/logout',
    '/dashboard', 
  ];

  constructor(private router: Router) { }
  

 // auth.service.ts (modificación)
hasPerms(url: string): boolean {
  const allowUrl = this.allow.find((e: any) => e === url);

  if (allowUrl) {
    return true;
  }

  if (localStorage.getItem('token') == null) {
    this.router.navigateByUrl('/pages/login');
    return false;
  }

  const permission = localStorage.getItem('permission')?.toString() || '';
  
  // Valida si permission es un JSON válido
  try {
    const data = JSON.parse(permission);
    const result = data.find((e: any) => e.url === url);
    return !!result;
  } catch (error) {
    console.error('Error al parsear permisos:', error);
    return false;
  }
}
}
